import React from 'react';
import { Route } from '../Routing/types';
import { AccessPage } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/access',
    element: <AccessPage returnUrl={`${window.location.origin}/access`} />,
    private: true,
    title: dummy_t('access.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
];

export default routes;
